const routes = {
  path: '',
  protected: false,
  children: [
    {
      path: '',
      protected: true,
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },

    {
      path: '/needconfirm',
      protected: true,
      load: () => import(/* webpackChunkName: 'home' */ './needconfirm'),
    },

    {
      path: '/consumption', // lecteur (type >= 40) : détail consommation par type
      protected: true,
      load: () => import(/* webpackChunkName: 'consumption' */ './consumptionreader'),
    },

    {
      path: '/meter', // lecteur (type >= 40) : relevés d'un compteur
      protected: true,
      load: () => import(/* webpackChunkName: 'consumption' */ './consumptionreadermeter'),
    },

    {
      path: '/synthesis', // lecteur (type >= 40) : bilan + graphiques des fluides
      protected: true,
      load: () => import(/* webpackChunkName: 'consumption' */ './synthesisreader'),
    },

    {
      path: '/alarms', // sa, a
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'alarms' */ './alarms'),
    },
    {
      path: '/negativeflow', // sa, a
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'negativeflow' */ './negativeflow'),
    },
    {
      path: '/tickets', // sa, a
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'tickets' */ './tickets'),
    },
    {
      path: '/tickets/:ticket_id', // sa, a
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'ticket' */ './ticket'),
    },

    {
      path: '/users', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroup'),
      params: { type: 40, part: 'user' },
    },
    {
      path: '/user', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './userset'),
      params: { type: 40 },
    },
    {
      path: '/usermulti', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'usermulti' */ './usermulti')
    },
    {
      path: '/user/:user_id', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './user'),
      params: { type: 40 },
    },
    {
      path: '/user/:user_id/sendnotif', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'sendnotif' */ './sendnotif'),
      params: { type: 40 },
    },
    {
      path: '/user/:user_id/set', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './userset'),
      params: { type: 40 },
    },
    {
      path: '/user/:user_id/keyview', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './keyview'),
      params: { type: 40 },
    },
    {
      path: '/user/:user_id/access', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 40 },
    },
    {
      path: '/user/:user_id/access/:access_type/:access_id/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 40 },
    },


    {
      path: '/admins', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroup'),
      params: { type: 10, part: 'user' },
    },
    {
      path: '/admin', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './userset'),
      params: { type: 10 },
    },
    {
      path: '/admin/settings', // sa (must be before /admin/:user_id)
      protected: true,
      load: () => import(/* webpackChunkName: 'adminsettings' */ './adminsettings'),
      params: {},
    },
    {
      path: '/admin/remoteaccess', // sa (must be before /admin/:user_id)
      protected: true,
      load: () => import(/* webpackChunkName: 'adminremoteaccess' */ './adminremoteaccess'),
      params: {},
    },
    {
      path: '/admin/:user_id', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './user'),
      params: { type: 10 },
    },
    {
      path: '/admin/:user_id/sendnotif', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'sendnotif' */ './sendnotif'),
      params: { type: 10 },
    },
    {
      path: '/admin/:user_id/set', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './userset'),
      params: { type: 10 },
    },
    {
      path: '/admin/:user_id/keyview', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './keyview'),
      params: { type: 10 },
    },
    {
      path: '/admin/:user_id/access', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 40 },
    },
    {
      path: '/admin/:user_id/access/:access_type/:access_id/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 40 },
    },

    {
      path: '/forgot',
      load: () =>
        import(/* webpackChunkName: 'forgot' */ './forgot'),
    },
    {
      path: '/recovery',
      load: () =>
        import(/* webpackChunkName: 'forgot' */ './recovery'),
    },
    {
      path: '/confirm',
      load: () => import(/* webpackChunkName: 'confirm' */ './confirm'),
    },
    {
      path: '/login',
      load: () => import(/* webpackChunkName: 'login' */ './login'),
    },
    {
      path: '/logout',
      load: () => import(/* webpackChunkName: 'logout' */ './logout'),
    },
    {
      path: '/profile', // sa, a, bm, tm, u
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './profile')
    },
    {
      path: '/setnotification', // sa, a, bm, tm, u
      protected: true,
      load: () => import(/* webpackChunkName: 'setnotification' */ './setnotification')
    },
    {
      path: '/setnotificationuser', // sa, a, bm, tm, u
      protected: true,
      load: () => import(/* webpackChunkName: 'setnotificationuser' */ './setnotificationuser')
    },
    {
      path: '/tools/email-templates', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'emailtemplates' */ './tools-email-templates')
    },
    {
      path: '/register',
      load: () => import(/* webpackChunkName: 'register' */ './register'),
    },

    {
      path: '/buildingmanagers', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroups'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroupset'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id', // sa, a, bm*
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroup'),
      params: { type: 20, part: 'group' },
    },
    {
      path: '/buildingmanager/:group_id/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroupset'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id/access', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id/access/:access_type/:access_id/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id/user', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './userset'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id/user/:user_id', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './user'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id/user/:user_id/sendnotif', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'sendnotif' */ './sendnotif'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id/user/:user_id/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './userset'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id/user/:user_id/access', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id/user/:user_id/access/:access_type/:access_id/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 20 },
    },
    {
      path: '/buildingmanager/:group_id/user/:user_id/keyview', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './keyview'),
      params: { type: 20 },
    },
    {
      path: '/technicals', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroups'),
      params: { type: 30 },
    },
    {
      path: '/technical', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroupset'),
      params: { type: 30 },
    },
    {
      path: '/technical/:group_id', // sa, a, bm*
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroup'),
      params: { type: 30, part: 'group' },
    },
    {
      path: '/technical/:group_id/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './usergroupset'),
      params: { type: 30 },
    },
    {
      path: '/technical/:group_id/user/:user_id', // sa, a, tm*
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './user'),
      params: { type: 30 },
    },
    {
      path: '/technical/:group_id/user/:user_id/sendnotif', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'sendnotif' */ './sendnotif'),
      params: { type: 30 },
    },
    {
      path: '/technical/:group_id/user/:user_id/set', // sa, a, tm*
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './userset'),
      params: { type: 30 },
    },
    {
      path: '/technical/:group_id/user/:user_id/access', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 20 },
    },
    {
      path: '/technical/:group_id/user/:user_id/access/:access_id/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './accessset'),
      params: { type: 20 },
    },

    {
      path: '/housings', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './housings'),
      params: {},
    },
    {
      path: '/housing/:housing_id', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './housing'),
      params: {},
    },
    {
      path: '/housing/:housing_id/set', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './housingset'),
      params: {},
    },
    {
      path: '/housing/:housing_id/synthesis', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './synthesis'),
      params: {},
    },
    {
      path: '/housing/:housing_id/consumption', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'consumption' */ './consumption'),
      params: {},
    },
    {
      path: '/housing/:housing_id/share', // sa, a, bm
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'housings' */ './under-construction'),
      params: {},
    },

    {
      path: '/devices', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './devices'),
      params: {},
    },

    {
      path: '/housinggroups', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './housinggroups'),
      params: {},
    },
    {
      path: '/housinggroup/:housinggroup_id', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './housinggroup'),
      params: {},
    },
    {
      path: '/housinggroup/:housinggroup_id/set', // sa, a, bm
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'housings' */ './housinggroupset'),
      params: {},
    },
    {
      path: '/housinggroup/:housinggroup_id/synthesis', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './synthesis'),
      params: {},
    },
    {
      path: '/housinggroup/:housinggroup_id/consumption', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'consumption' */ './consumption'),
      params: {},
    },
    {
      path: '/housinggroup/:housinggroup_id/share', // sa, a, bm
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'housings' */ './under-construction'),
      params: {},
    },
    {
      path: '/housinggroup/:housinggroup_id/box/:box_id/set', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'boxset' */ './boxset'),
      params: {},
    },

    {
      path: '/jointhousinggroups', // sa, a, bm
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'housings' */ './jointhousinggroups'),
      params: {},
    },
    {
      path: '/jointhousinggroup/:jointhousinggroup_id', // sa, a, bm
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'housings' */ './jointhousinggroup'),
      params: {},
    },
    {
      path: '/jointhousinggroup/:jointhousinggroup_id/set', // sa, a, bm
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'housings' */ './jointhousinggroupset'),
      params: {},
    },
    {
      path: '/jointhousinggroup/:jointhousinggroup_id/synthesis', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './synthesis'),
      params: {},
    },
    {
      path: '/jointhousinggroup/:jointhousinggroup_id/consumption', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'consumption' */ './consumption'),
      params: {},
    },
    {
      path: '/jointhousinggroup/:jointhousinggroup_id/share', // sa, a, bm
      protected: true,
      load: () =>
        import(/* webpackChunkName: 'housings' */ './under-construction'),
      params: {},
    },
    {
      path: '/jointhousinggroup/:jointhousinggroup_id/document', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'documents' */ './documents'),
      params: { type: 10 },
    },
    {
      path: '/jointhousinggroup/:jointhousinggroup_id/document/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'documentset' */ './documentset'),
      params: { type: 10 },
    },
    {
      path: '/jointhousinggroup/:jointhousinggroup_id/document/:document_id/set', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'documentset' */ './documentset'),
      params: { type: 10 },
    },


    {
      path: '/deviceimport', // sa, a, bm, tm
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './deviceimport'),
    },

    {
      path: '/ediimport', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './ediimport'),
    },

    {
      path: '/device/:device_id/set', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'housings' */ './deviceset'),
      params: {},
    },

    {
      path: '/notifications', // sa, a, tm*
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './under-construction'),
    },
    {
      path: '/notificationset', // sa, a, tm*
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './under-construction'),
    },
    {
      path: '/notificationset/:id', // sa, a, tm*
      protected: true,
      load: () => import(/* webpackChunkName: 'setadmin' */ './under-construction'),
    },


    {
      path: '/ftpfiles/:source', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'ftpfiles' */ './ftpfiles'),
      params: {},
    },
    {
      path: '/ftpfiles/:source/:file_id', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'ftpfiles' */ './ftpfiles'),
      params: {},
    },
    // Accès au fichier de trames d'un relevé, par uid de boîtier + horodatage de la trame.
    // Préfixe distinct : `/ftpfiles/:uid/:ts` serait indiscernable de la route ci-dessus.
    {
      path: '/ftpframe/:uid/:ts', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'ftpframe' */ './ftpframe'),
      params: {},
    },
    // Même page, l'identifiant du fichier en plus : les relevés récents le portent dans
    // leur `origin`, ce qui dispense de toute recherche.
    {
      path: '/ftpframe/:uid/:ts/:file_id', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'ftpframe' */ './ftpframe'),
      params: {},
    },
    {
      path: '/meters', // sa, a
      protected: true,
      load: () => import(/* webpackChunkName: 'meters' */ './meters'),
    },

    {
      path: '/tools', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'tools' */ './tools')
    },

    {
      path: '/tools/extract-readings', // sa
      protected: true,
      load: () => import(/* webpackChunkName: 'tools-extract-readings' */ './tools-extract-readings')
    },

    {
      path: '/boxes', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'boxes' */ './boxes'),
      params: {},
    },
    {
      path: '/box/:box_id/set', // sa, a, bm
      protected: true,
      load: () => import(/* webpackChunkName: 'boxset' */ './boxset'),
      params: {},
    },

    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    if(typeof route ==='object'){
      route.title = `${route && route.title || ''}`;
      route.description = route && route.description || '';
    }

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;
